module.exports = __webpack_public_path__ + "img/logo-pz.e1ad30b2.png";